import React from 'react'
import { compose } from 'recompose'
import { withStyles, Grid, Typography, Divider, Stepper, Step, StepLabel } from '@material-ui/core'
import EmojiObjectsIcon from '@material-ui/icons/ArrowBack'
import themeCreateInjectableStyles from 'Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support'
import ProgressDoneStyle from './ProgressDone.style'
import cn from 'classnames'
import Spinner from 'Components/Spinner/Spinner.component'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'

interface Props {
  title: string,
  stepContents: string[],
}
interface InjectedProps {
  classes: any,
}
const ProgressDoneComp = (props: Props & InjectedProps) => {
  const {
    title,
    stepContents = [],
    classes,
  } = props
  return (
    <React.Fragment>
      <div className={cn(classes.topWrapper, classes.topWrapperDone)}>
        <div className={classes.flexCenter}>
          <CheckCircleOutlineIcon className={classes.checkIcon} color='primary' />
        </div>
        <Typography className={classes.submittedText} align='center' variant='h6'>
          { title }
        </Typography>
      </div>
      <Divider />
      <Typography className={classes.nextStepsTitle} color='primary' align='center' variant='h6'>
        {`What happens next?`}
      </Typography>
      <Stepper orientation='vertical'>
        { stepContents.map((content) => {
          return (
            <Step active key={content}>
              <StepLabel>{ content }</StepLabel>
            </Step>
          )
        })}
      </Stepper>
      <Divider />
    </React.Fragment>
  )
}

const ProgressDone = compose<Props & InjectedProps, Props>(
  withStyles(themeCreateInjectableStyles(ProgressDoneStyle) as any, { withTheme: true }),
)(ProgressDoneComp)

export default ProgressDone
